Vue.component('group', {
  props: ['group_id', 'user', 'teams'],

  data() {
    return {
      newLocation: '',
      locations: [],
      selectedLocation: null,
      selectedLocationForAssignment: null,
      editedLocationName: '',
      filteredGroupTeams: [],
      params: {
        fromDate: moment().startOf('year').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        previousFromDate: moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
        previousToDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        dateRange: 'Year To Date',
      },
      group_teams: [],
      selectedTeamIds: [],
      isComparisonActive: false,
      isLocationAssignActive: false,
      isLoading: false,
      reportEmail: Spark.state.user.email,
      selectedReportType: 'pdf',
      reportSent: false,
    };
  },

  computed: {
    formattedParams() {
      return this.params;
    },
    selectAllText() {
      if (this.selectedTeamIds.length == this.group_teams.length) {
        return this.__('Deselect All');
      } else {
        return this.__('Select All');
      }
    },
    comparisonTeams() {
      let instance = this;

      let teams = this.group_teams.filter(function (team) {
        return instance.selectedTeamIds.includes(team.team_id);
      });

      return teams;
    },
    teamToLocationMap() {
      let mapping = {};
      this.locations.forEach((location) => {
        if (location.teams && Array.isArray(location.teams)) {
          location.teams.forEach((team) => {
            mapping[team.id] = location.name;
          });
        }
      });
      return mapping;
    },
  },

  mounted() {
    this.$eventHub.$on('updateAndOpenModal', (team_id, params, toggleSentiment = false) =>
      this.openReviewsModal(team_id, params, toggleSentiment),
    );
    this.$eventHub.$on('toggleTeamForComparison', (team_id, toggle) => this.toggleComparisonTeam(team_id, toggle));
    this.getLocations();
    this.updateGroup();
  },
  watch: {
    selectedLocationForAssignment(newValue) {
      if (newValue) {
        this.selectedTeamIds = newValue.teams.map((team) => team.id);
      } else {
        this.selectedTeamIds = [];
      }
    },
  },
  methods: {
    getLocations() {
      axios
        .get('/api/groups/' + this.group_id + '/locations')
        .then((response) => {
          this.locations = response.data.map((location) => {
            const teams = Object.entries(location.teams).map(([id, name]) => ({ id: parseInt(id), name }));
            return {
              id: location.id,
              name: location.name,
              teams: teams,
            };
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    toggleLocationAssignment() {
      this.isLocationAssignActive = !this.isLocationAssignActive;
    },
    openAddLocationModal() {
      $('#addLocationModal').modal('show');
    },
    assignPropertiesToLocation() {
      if (this.selectedLocationForAssignment) {
        let teamIds = this.comparisonTeams.map((team) => team.team_id);
        let locationId = this.selectedLocationForAssignment.id;

        axios
          .post(`/api/groups/${this.group_id}/locations/${locationId}/assign`, {
            teamIds: teamIds,
          })
          .then((response) => {
            swal(
              {
                title: 'Success!',
                text: 'Teams have been successfully assigned to the location.',
                type: 'success',
                confirmButtonText: 'OK',
                closeOnConfirm: true,
              },
              () => {
                this.getLocations();
                this.selectedLocationForAssignment = null;
              },
            );
          })
          .catch((error) => {
            console.error(error);
            if (error.response && error.response.data && error.response.data.conflicts) {
              let conflicts = error.response.data.conflicts;
              let conflictText = 'The following teams are already assigned: <br><br>';
              conflicts.forEach((conflict) => {
                conflictText += `Team: <strong>${conflict.team}</strong> is assigned to Location: <strong>${conflict.location}</strong><br>`;
              });
              swal({
                title: 'Error!',
                text: conflictText,
                type: 'error',
                confirmButtonText: 'OK',
                html: true,
              });
            } else {
              swal({
                title: 'Error!',
                text: 'There was an error assigning teams to the location.',
                type: 'error',
                confirmButtonText: 'OK',
              });
            }
          });
      }
    },
    openEditLocationModal() {
      this.editedLocationName = this.selectedLocation.name;
      $('#editLocationModal').modal('show');
    },
    editLocation() {
      if (this.editedLocationName) {
        axios;
        axios
          .put(`/api/groups/${this.group_id}/locations/${this.selectedLocation.id}`, {
            name: this.editedLocationName,
          })
          .then((response) => {
            this.selectedLocation.name = this.editedLocationName;
            $('#editLocationModal').modal('hide');
            swal({
              title: 'Success!',
              text: 'Location name updated successfully!',
              type: 'success',
              confirmButtonText: 'OK',
            });
          })
          .catch((error) => {
            console.error(error);
            swal({
              title: 'Error!',
              text: 'There was an error updating the location name.',
              type: 'error',
              confirmButtonText: 'OK',
            });
          });
      }
    },
    addLocation() {
      const isValidLocation = /^[A-Za-z0-9\-]+$/g.test(this.newLocation);

      if (!isValidLocation) {
        swal({
          title: 'Error!',
          text: 'Location name can only contain characters, numbers and "-".',
          type: 'error',
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'OK',
        });
        return;
      }

      if (this.newLocation) {
        axios
          .post(`/api/groups/${this.group_id}/locations/create`, {
            name: this.newLocation,
          })
          .then((response) => {
            this.locations.push(response.data.name);
            this.newLocation = '';
            $('#addLocationModal').modal('hide');
            this.getLocations();
            swal({
              title: 'Success!',
              text: 'Location added successfully!',
              type: 'success',
              confirmButtonText: 'OK',
            });
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              swal({
                title: 'Error!',
                text: error.response.data.error,
                type: 'error',
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'OK',
              });
            } else {
              console.error(error);
            }
          });
      }
    },
    removeLocation() {
      if (this.selectedLocation) {
        swal(
          {
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this location!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, delete it!',
            closeOnConfirm: false,
          },
          () => {
            axios
              .delete(`/api/groups/${this.group_id}/locations/${this.selectedLocation.id}`)
              .then((response) => {
                const index = this.locations.indexOf(this.selectedLocation);
                if (index > -1) {
                  this.locations.splice(index, 1);
                  this.selectedLocation = null;
                  swal('Deleted!', 'The location has been removed.', 'success');
                }
              })
              .catch((error) => {
                swal('Error!', 'The location could not be removed. Please try again.', 'error');
              });
          },
        );
      }
    },
    filterPropertiesByLocation() {
      if (this.selectedLocation) {
        let teamIdsForSelectedLocation = this.selectedLocation.teams.map((team) => team.id);

        this.filteredGroupTeams = this.group_teams.filter((team) => teamIdsForSelectedLocation.includes(team.team_id));
        this.selectedTeamIds = this.filteredGroupTeams.map((team) => team.team_id);
      } else {
        this.filteredGroupTeams = this.group_teams;
      }
    },
    resetLocation() {
      this.selectedLocation = null;
      this.filterPropertiesByLocation();
    },
    exportGroupReport() {},
    sendExportRequest() {
      let link = `/api/report/group/${this.group_id}/adhoc`;

      let body = {
        fromDate: this.params.fromDate,
        toDate: this.params.toDate,
        report_type: this.selectedReportType,
        previousFromDate: this.params.previousFromDate,
        previousToDate: this.params.previousToDate,
        email: this.reportEmail,
      };

      axios.post(link, body).then((response) => {
        this.showSuccessMessage();
      });
    },
    showSuccessMessage() {
      this.reportSent = true;
      var instance = this;
      setTimeout(function () {
        instance.reportSent = false;
      }, 5000);
    },
    selectAll() {
      if (this.selectedTeamIds.length == this.group_teams.length) {
        this.selectedTeamIds = [];
      } else {
        this.selectedTeamIds = this.group_teams.map((t) => t.team_id);
      }
    },
    toggleComparisonTeam(team_id, toggle) {
      if (toggle) {
        this.selectedTeamIds.push(team_id);
      } else {
        let index = this.selectedTeamIds.indexOf(team_id);

        if (index !== -1) this.selectedTeamIds.splice(index, 1);
      }
    },
    toggleComparisonSelection() {
      this.isComparisonActive = !this.isComparisonActive;
    },
    updateDates(from, to, dateRange) {
      this.params.fromDate = from;
      this.params.toDate = to;
      this.params.dateRange = dateRange;

      analytics.track('Filtered Group Overview', {
        filtered_by: 'date',
      });

      this.updateGroup();
    },
    updateComparisonDates(from, to, dateRange) {
      this.params.previousFromDate = from;
      this.params.previousToDate = to;
      this.params.compareDateRange = dateRange;
    },
    openComparisonModal() {
      analytics.track('Opened Group Comparison');

      // use ratings as default active type
      this.$eventHub.$emit('openComparison', 'average_rating');
      $(this.$refs.compare_modal).modal('toggle');
    },
    openReviewsModal(team_id, params, toggleSentiment = false) {
      Spark.state.currentTeam.id = team_id;

      params.fromDate = this.params.fromDate;
      params.toDate = this.params.toDate;

      this.$eventHub.$emit('activateTab', 'reviews');

      $(this.$refs.reviews_modal).modal('toggle');

      this.$eventHub.$emit('applyFilters', params);

      if (toggleSentiment) {
        this.$eventHub.$emit('toggleSentimentAnalysisTable', true);
      }
    },
    updateGroup() {
      this.loading = true;
      axios
        .get(`/api/groups/${this.group_id}?${this.formatParamsForUrl(this.formattedParams)}`)
        .then((response) => {
          this.loading = false;
          this.group_teams = response.data;
          this.$eventHub.$emit('updateCharts', true);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
});
